import { AxiosInstance, AxiosResponse, AxiosRequestConfig } from "axios"

import { ResponseData } from "../common"
import { TravellerInfo, AddGuestDetailsProps } from "./types"

export interface TravellerAddressResponseData extends ResponseData {
  bookingData: {
    adultNumber: number
    bookingAddress: TravellerInfo
    bookingId: number
    bookingNumber: string
    childNumber: number
    differentBillingAddress: boolean
    isConfirmedByPmc: boolean
  }
  duplicateEmailIds?: string
}

export interface GetTravellerAddressResponse extends AxiosResponse {
  data: TravellerAddressResponseData
}

export interface GuestInfoParams {
  bookingNumber?: string | null
  guestInfo?: AddGuestDetailsProps[]
}

export interface BookingGuestinfoRequest extends Partial<AxiosRequestConfig> {
  params: GuestInfoParams
}

export function getTravellerAddressApi(
  axiosInstance: AxiosInstance,
): Promise<GetTravellerAddressResponse> {
  return axiosInstance({
    method: "get",
    url: `/booking/get-last-booking-data`,
  }) as Promise<GetTravellerAddressResponse>
}

export function bookingGuestInfoApi(
  { params }: BookingGuestinfoRequest,
  axiosInstance: AxiosInstance,
): Promise<GetTravellerAddressResponse> {
  const url = `/booking/booking-guest-info`

  return axiosInstance({
    data: params,
    method: "Post",
    url,
  }) as Promise<GetTravellerAddressResponse>
}
